<ng-container *ngIf="element">
    <syslink-title
        *ngIf="element.No"
        [text]="element.No"
    ></syslink-title>

    <syslink-toolbar [actions]="toolbarActions"></syslink-toolbar>

    <app-document-statuses
        #documentStatuses
        [statuses]="availableStatuses"
        [documentStatuses]="element.Statuses"
        (statusChanged)="onDocumentStatusChanged($event)"
    ></app-document-statuses>

    <div class="mt-3 mb-5">
        <app-stock-move-document-form
            [(element)]="element"
            [reportType]="reportType"
            [subModuleCode]="subModuleCode"
            [disabled]="!canEditDocument()"
        ></app-stock-move-document-form>
    </div>

    <div class="mt-4">
        <syslink-tabs>
            <syslink-tab
                label="Content"
                key="Content"
                [visible]="authService.hasPermission(this.basePermissionKey + '.content.tab.view')"
            >
                <app-stock-move-document-content
                    [(element)]="element"
                    [reportType]="reportType"
                    [subModuleCode]="subModuleCode"
                    (selectedKeyChange)="onSelectedKeyChange($event)"
                    [StockMoveDocumentService]="StockMoveDocumentService"
                    [StockMoveDocumentLinesService]="StockMoveDocumentLinesService"
                    [columns]="documentLinesColumns"
                    [disabled]="!canEditDocument()"
                    [type]="type"
                    (elementLineChange)="onElementLineChange($event)"
                ></app-stock-move-document-content>
            </syslink-tab>

            <syslink-tab
                label="Third"
                key="Third"
                [visible]="authService.hasPermission(this.basePermissionKey + '.third.tab.view')"
            >
                <app-stock-move-document-third
                    #StockMoveDocumentThird
                    [(element)]="element"
                    [reportType]="reportType"
                    (documentData)="update(false)"
                    [disabled]="!canEditDocument()"
                    [type]="type"
                ></app-stock-move-document-third>
            </syslink-tab>

            <syslink-tab
                label="Other"
                key="Other"
                [visible]="authService.hasPermission(this.basePermissionKey + '.other.tab.view')"
            >
                <app-stock-move-document-other
                    #StockMoveDocumentOther
                    [(element)]="element"
                    [reportType]="reportType"
                    (globalDiscountChanged)="update()"
                    [disabled]="!canEditDocument()"
                ></app-stock-move-document-other>
            </syslink-tab>
        </syslink-tabs>
    </div>
    <div
        class="mt-4"
        *ngIf="element.Id"
    >
        <app-document-relations
            #defaultStockMoveDocumentRelation
            [reportType]="reportType"
            [documentId]="element.Id"
            [service]="StockMoveDocumentService"
            [documentRelations]="element.DocumentRelations"
            (onRefreshClicked)="reloadDocumentRelation()"
        ></app-document-relations>
    </div>

    <app-mail-modal
        #emailModal
        *ngIf="mailTemplateType && mailModel"
        [(mailModel)]="mailModel"
        [mailTemplateType]="mailTemplateType"
        [element]="element"
    ></app-mail-modal>

    <syslink-confirm-modal
        #deleteConfirm
        title="Delete"
        content="DeleteConfirmMessage"
        (onValidate)="onDeleteConfirmed()"
        validateText="Confirm"
        cancelText="Cancel"
    ></syslink-confirm-modal>

    <app-document-copy-modal
        #copyModal
        (validate)="onCopyButtonClicked($event)"
    ></app-document-copy-modal>
</ng-container>